<template>
  <div>
    <a-tabs defaultActiveKey="1">
      <a-tab-pane tab="REPORTES" key="1">
        <a-row>
          <g-master name="reportes"
                    :endpoint="master.endpoint"
                    :tableSetup="master.tableSetup"
                    :modalFieldsSetup="master.modalFieldsSetup"
                    ref="master"
                    :useMultipart="true"
                    modalWidth="80%"
                    :beforeSend="master.beforeSend"
                    @action="masterAction"
          >
            <span slot="estadoRenderer" slot-scope="{text}">
              <div v-if="text ==='INACTIVO'">
                <a-tag color="red">{{text}}</a-tag>
              </div>
              <div v-if="text ==='ACTIVO'">
                <a-tag color="blue">{{text}}</a-tag>
              </div>
              <div v-if="text ==='BLOQUEADO'">
                <a-tag color="purple">{{text}}</a-tag>
              </div>
            </span>
            <template slot="masterModal" slot-scope="{record}">
              <a-row :gutter="[16,16]">
                <a-col v-bind="colOptions">
                  <g-dropdown v-bind="fiOptions"
                              endpoint="hierarchy_lookup"
                              :label="$t('Categoría')"
                              :formItemConfig="fiOptions"
                              :decorator="['id_h_topic_report', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                              :params="categoria">
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Código')">
                    <a-input style="width: 100%;"
                             v-decorator="['code_report', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown v-bind="fiOptions"
                              endpoint="hierarchy_lookup"
                              :label="$t('Estado')"
                              :formItemConfig="fiOptions"
                              :decorator="['status', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                              :params="estado">
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown v-bind="fiOptions"
                              endpoint="hierarchy_lookup"
                              :label="$t('Tipo de salida')"
                              :formItemConfig="fiOptions"
                              :decorator="['tipo_salida', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                              :params="tipo_salida">
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown v-bind="fiOptions"
                              endpoint="hierarchy_lookup"
                              :label="$t('Clase de reporte')"
                              :formItemConfig="fiOptions"
                              :decorator="['id_h_clase_reporte', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                              :params="clase_reporte">
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Ruta clase reporte')">
                    <a-textarea auto-size
                                v-decorator="['report_class', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Subir archivo')">
                    <a-upload
                      name="profile_file"
                      :before-upload="beforeUpload"
                      :fileList="master.uploads.report_file"
                      :remove="() => { master.uploads.report_file = [] }">
                      <a-button style="width: 100%">Seleccionar archivo</a-button>
                    </a-upload>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Subir archivo fuente')">
                    <a-upload
                      name="profile_file"
                      :before-upload="beforeUploadSource"
                      :fileList="master.uploads.file_source"
                      :remove="() => { master.uploads.file_source = [] }">
                      <a-button style="width: 100%">Seleccionar archivo</a-button>
                    </a-upload>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Autogestión')" :has-feedback="false">
                    <a-checkbox v-decorator="['self_service', {valuePropName: 'checked'}]">
                    </a-checkbox>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Log')" :has-feedback="false">
                    <a-checkbox v-decorator="['log', {valuePropName: 'checked'}]">
                    </a-checkbox>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Reporte masivo')" :has-feedback="false">
                    <a-checkbox v-decorator="['masivo', {valuePropName: 'checked'}]">
                    </a-checkbox>
                  </a-form-item>
                </a-col>
                <a-col v-if="isConsEmpVisible" v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Consulta de empleados')">
                    <a-textarea auto-size
                                v-decorator="['sql_masive', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
              </a-row>
            </template>
          </g-master>
          <a-tabs defaultActiveKey="1">
            <a-tab-pane tab="Traducciones del reporte" key="1">
              <report-tl v-if="idReport" @handleOk="refreshDatatable" :id_report="idReport"/>
              <span v-else>Seleccione un reporte para ver más.</span>
            </a-tab-pane>
            <a-tab-pane tab="Parámetros del reporte" key="2">
              <report-parameter v-if="idReport" :id_report="idReport"/>
              <span v-else>Seleccione un reporte para ver más.</span>
            </a-tab-pane>
          </a-tabs>
        </a-row>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
  import JsUtils from '@/util/JsUtils'
  import HttpUtil from '@/util/HttpUtil'

  export default {
    data () {
      return {
        loadingBtns: {},
        categoria: {
          h_lookup_type: 'TEMAS_REPORTES'
        },
        isConsEmpVisible: false,
        estado: {
          h_lookup_type: 'ESTADO_SNB',
          use_code: true
        },
        tipo_salida: {
          h_lookup_type: 'TIPO_SALIDA',
          use_code: true
        },
        clase_reporte: {
          h_lookup_type: 'CLASE_REPORTE'
        },
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        colOptions: {xs: 24, sm: 12},
        master: {
          uploads: {
            report_file: [],
            file_source: []
          },
          beforeSend: (data) => {
            if (this.master.uploads.report_file.length > 0) {
              data.report_file = this.master.uploads.report_file[0]
            }

            if (this.master.uploads.file_source.length > 0) {
              data.file_source = this.master.uploads.file_source[0]
            }

            if (data.log) {
              data.log = 'Y'
            } else {
              data.log = 'N'
            }

            if (data.self_service) {
              data.self_service = 'Y'
            } else {
              data.self_service = 'N'
            }

            if (data.masivo) {
              data.masivo = 'Y'
            } else {
              data.masivo = 'N'
            }
            return data
          },
          endpoint: 'dropdown_report',
          tableSetup: {
            allowSelect: true,
            selectedRows: [],
            actions: {
              actions: [
                {
                  name: 'masterEdit',
                  text: 'Editar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'edit'}
                },
                {
                  name: 'masterDelete',
                  text: 'Eliminar',
                  permisos: [],
                  props: {size: 'small', icon: 'delete', type: 'link'}
                },
                {
                  name: 'download',
                  text: 'Descargar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'download', style: 'color: red'},
                  fnVisible: (record) => {
                    if (!JsUtils.isEmpty(record.file_source_content_type)) {
                      return true
                    } else {
                      return false
                    }
                  },
                  fnLoading: (record) => {
                    return this.loadingBtns[record.id_report] === record.id_report
                  }
                }
              ]
            },
            customSlots: ['estadoRenderer'],
            tableConfig: {
              rowKey: 'id_report'
            },
            columns: [
              {title: '#', dataIndex: 'id_report', sorter: true},
              {title: 'Categoria', dataIndex: 'categoria', sorter: true},
              {title: 'Código', dataIndex: 'code_report', sorter: true},
              {title: 'Autogestión', dataIndex: 'self_service_desc', sorter: true},
              {
                title: 'Estado',
                dataIndex: 'status_desc',
                sorter: true,
                width: 130,
                scopedSlots: {
                  customRender: 'estadoRenderer'
                }
              },
              {title: 'Log', dataIndex: 'log_desc', sorter: true},
              {title: 'Nombre', dataIndex: 'nombre_reporte', sorter: true},
              {title: 'Reporte masivo', dataIndex: 'masivo_desc', sorter: true},
              {title: 'Ruta clase del reporte', dataIndex: 'report_class', sorter: true},
            ]
          },
          modalFieldsSetup: [
            {name: 'id_h_topic_report'},
            {name: 'code_report'},
            {name: 'self_service'},
            {name: 'status'},
            {name: 'log'},
            {name: 'tipo_salida'},
            {name: 'masivo'},
            {name: 'sql_masive'},
            {name: 'id_h_clase_reporte'},
            {name: 'report_class'},
            {name: 'sql_masive'}
          ]
        }
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
    },
    methods: {
      refreshDatatable () {
        this.$refs.master.$refs.datatable.loadData()
      },
      beforeUpload (file) {
        if (this.validateFile(file)) {
          this.master.uploads.report_file = [file]
        }
        return false
      },
      beforeUploadSource (file) {
        if (this.validateFileSource(file)) {
          this.master.uploads.file_source = [file]
        }
        return false
      },
      validateFile (file) {
        const array = ['jasper']
        const isValidateFile = file.name.split('.')
        if (!array.includes(isValidateFile[isValidateFile.length - 1])) {
          this.$message.error('Solo se pemiten documentos tipo jasper')
          return false
        }
        const isLt2M = file.size / 1024 / 1024 < 2
        if (!isLt2M) {
          this.$message.error('El tamaño del archivo no puede ser mayor a 2 Megas.')
          return false
        }
        return true
      },
      validateFileSource (file) {
        const array = ['jrxml']
        const isValidateFile = file.name.split('.')
        if (!array.includes(isValidateFile[isValidateFile.length - 1])) {
          this.$message.error('Solo se pemiten documentos tipo jrxml')
          return false
        }
        const isLt2M = file.size / 1024 / 1024 < 2
        if (!isLt2M) {
          this.$message.error('El tamaño del archivo no puede ser mayor a 2 Megas.')
          return false
        }
        return true
      },

      download (id_report) {
        this.loadingBtns[id_report] = id_report
        this.loadingBtns = Object.assign({}, this.loadingBtns)
        this.httpClient.getInstance().get('report/download/' + id_report, {
          responseType: 'arraybuffer'
        })
          .then((response) => {
            let blob = new Blob([response.data], {type: response.headers['content-type']})
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = response.headers['x-nombre-archivo']
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            delete this.loadingBtns[id_report]
            this.loadingBtns = Object.assign({}, this.loadingBtns)
          })
          .catch((error) => {
            console.log(error)
          })
      },

      masterAction (action) {
        switch (action.action) {
          case 'masterEdit':
            if (action.record.log === 'Y') {
              this.$refs.master.modal.form.setFieldsValue({
                log: true
              })
            } else {
              this.$refs.master.modal.form.setFieldsValue({
                log: false
              })
            }

            if (action.record.self_service === 'Y') {
              this.$refs.master.modal.form.setFieldsValue({
                self_service: true
              })
            } else {
              this.$refs.master.modal.form.setFieldsValue({
                self_service: false
              })
            }

            if (action.record.masivo === 'Y') {
              this.isConsEmpVisible = true
              this.$refs.master.modal.form.setFieldsValue({
                masivo: true
              })
            } else {
              this.isConsEmpVisible = false
              this.$refs.master.modal.form.setFieldsValue({
                masivo: false
              })
            }
            break

          case 'masterCreate':
            this.master.uploads.file_source = []
            this.master.uploads.report_file = []
            break

          case 'fieldsChange':
            if (!JsUtils.isEmpty(action.changedFields.masivo)) {
              if (action.changedFields.masivo.value) {
                this.isConsEmpVisible = true
              } else {
                this.isConsEmpVisible = false
              }
            }
            break
          case 'download':
            this.download(action.record.id_report)
            break
        }
      }
    },
    computed: {
      idReport () {
        return this.master.tableSetup.selectedRows.length > 0 ? this.master.tableSetup.selectedRows[0].id_report : null
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Report/Report.vue